import Medalla from './medalla';

export default function SelecDia({ fecha, fechaTxt, medalla, clicked, icono}: { fecha: any; fechaTxt:any; medalla:any; clicked:any; icono:any}) {


    return (
       <div  className={`selecDia ${medalla !== -2 ? "hecho" : ""}`}  onClick={clicked}>
            
            <h2 className={`tituloJuego ${medalla == -2 ? "sin-medalla" : ""}`}> {fechaTxt}</h2>
            <Medalla num={medalla}></Medalla>

            {medalla == -2 ? <h3 className="labelJugar"  >Jugar</h3> : ''}
            
        </div>

    );



   
  
}//<img className={"iconoJuego "} src={"./"+icono}/>